const makeCodeBlock = ({text} = {}) => ({
  type: 'code-block',
  children: [{
    text: text || '',
  }],
});

export default makeCodeBlock;
